import * as React from "react";

function SvgPlateInfo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 21.25V0h21.25v11.421c.464-.058.937-.088 1.417-.088C28.926 11.333 34 16.41 34 22.667 34 28.927 28.926 34 22.667 34s-11.334-5.073-11.334-11.333c0-.48.03-.953.088-1.417H0zm13.82-5.667a11.326 11.326 0 00-1.662 2.834h-.825v-2.834h2.487zm4.597-3.425a11.33 11.33 0 00-2.834 1.662v-2.487h2.834v.825zm2.239 9.092c-.303 0-.548.2-.548.503v1.096c0 .303.245.549.548.549h.548v2.925h-.548a.548.548 0 00-.548.548v1.097c0 .303.245.548.548.548h4.021a.548.548 0 00.549-.548V26.87a.548.548 0 00-.549-.548h-.548v-4.57c0-.513-.381-.508-.678-.504l-.076.001h-2.719zM5.666 2.833H2.834v2.834h2.834V2.833zm4.25 0H7.084v2.834h2.834V2.833zm4.25 0h-2.833v2.834h2.834V2.833zm4.25 0h-2.833v2.834h2.834V2.833zM2.834 7.083h2.834v2.834H2.833V7.083zm7.084 0H7.083v2.834h2.834V7.083zm4.25 0h-2.834v2.834h2.834V7.083zm4.25 0h-2.834v2.834h2.834V7.083zm-12.75 4.25H2.833v2.834h2.834v-2.834zm1.416 0h2.834v2.834H7.083v-2.834zm4.25 0h2.834v2.834h-2.834v-2.834zm-8.5 4.25h2.834v2.834H2.833v-2.834zm7.084 0H7.083v2.834h2.834v-2.834zm15.172 2.834a1.92 1.92 0 10-3.839 0 1.92 1.92 0 003.839 0z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPlateInfo;
